module.exports = __webpack_public_path__ + "img/search-not-found.5f1e7d6d.png";